








import { Component, Mixins } from 'vue-property-decorator';
import { Actions } from '@/ts/store/Constants';
import DeviceMethods from '@/mixins/DeviceMethods.vue';

@Component
export default class MobileMenuButton extends Mixins(DeviceMethods) {
    constructor() {
        super();
    }

    get leftHeaderButton() {
        return this.$store.getters['Viewport/leftHeaderButton'];
    }

    public toggleMobileAside() {
        this.shelfVisible ? this.$store.dispatch(Actions.HIDE_SHELF) : this.$store.dispatch(Actions.SHOW_SHELF);
    }
}
